/* Reuse Dawn navigation and resize handling; count complete desktop cards
   correctly when the final card has no trailing gap or partial-card preview. */
customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('fa-collection-slider')) return;
  customElements.define('fa-collection-slider', class extends customElements.get('slider-component') {
    isSlideVisible(element, offset = 0) {
      // Fractional card widths can leave the final snapped edge just outside rounding.
      const left = this.slider.scrollLeft;
      return element.offsetLeft + element.clientWidth <= left + this.slider.clientWidth - offset + 2
        && element.offsetLeft >= left - 2;
    }
    initPages() {
      super.initPages();
      if (!this.slider || !this.sliderItemOffset || (!window.matchMedia('(min-width: 750px)').matches && !this.classList.contains('fa-link-grid__slider'))) return;
      const gap = parseFloat(getComputedStyle(this.slider).columnGap) || 0;
      this.slidesPerPage = Math.max(1, Math.floor((this.slider.clientWidth + gap + 1) / this.sliderItemOffset));
      this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      this.update();
    }
  });
});
